import React, { useEffect, useState } from "react";
import { AlertTriangle, Phone } from "lucide-react";
import { BRAND } from "@/branding";

const STORAGE_KEY = "sgc_disclaimer_ack";

export default function DisclaimerModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem(STORAGE_KEY)) setOpen(true);
  }, []);

  const accept = () => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      data-testid="disclaimer-overlay"
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-950/80 backdrop-blur-sm p-4"
    >
      <div
        data-testid="disclaimer-modal"
        className="w-full max-w-lg rounded-2xl border border-amber-500/40 bg-slate-900 shadow-2xl shadow-black/50 overflow-hidden"
      >
        <div className="flex items-center gap-3 bg-amber-500/15 border-b border-amber-500/30 px-6 py-4">
          <AlertTriangle className="h-6 w-6 text-amber-400 shrink-0" />
          <h2 className="text-lg font-bold tracking-wide text-amber-300 uppercase">
            Avviso Importante
          </h2>
        </div>

        <div className="px-6 py-6 space-y-4">
          <p className="text-base leading-relaxed text-slate-200">
            Questo sito è un{" "}
            <span className="font-semibold text-amber-300">progetto di test indipendente</span>,{" "}
            <span className="font-semibold text-amber-300">
              non affiliato ad alcun ente istituzionale o servizio di emergenza
            </span>
            . Non utilizzare per emergenze reali.
          </p>

          {BRAND.emergencyNumber && (
            <div className="flex items-center gap-3 rounded-lg border border-red-500/40 bg-red-500/10 px-4 py-3">
              <Phone className="h-5 w-5 text-red-400 shrink-0" />
              <p className="text-base font-semibold text-red-200">
                In caso di emergenza, chiamare il{" "}
                <span className="text-xl font-bold text-red-300">{BRAND.emergencyNumber}</span>
              </p>
            </div>
          )}
        </div>

        <div className="px-6 pb-6">
          <button
            data-testid="disclaimer-accept-btn"
            onClick={accept}
            className="w-full rounded-lg bg-amber-500 px-4 py-3 text-base font-semibold text-slate-950 transition-colors hover:bg-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-300 focus:ring-offset-2 focus:ring-offset-slate-900"
          >
            Ho capito, prosegui
          </button>
        </div>
      </div>
    </div>
  );
}
